var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text_item",style:({
  fontSize:_vm.fontSize,
  fontWeight:_vm.fontWeight,
  minWidth:_vm.minWidth,
  maxWidth:_vm.maxWidth,
  minHeight:_vm.minHeight,
  maxHeight:_vm.maxHeight,
  fontFamily:_vm.fontFamily,
  overflow:_vm.overflow
})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }